import checkPermission from "@/domain/permissions";
import { PermissionAttributes } from "@/domain/permissions/permissions.types";
import { useMainStore } from "@/infra/store";

import { computed } from "vue";

export default function usePermission() {
  const userSession = computed(() => useMainStore().session);
  const partnership_id = computed(() => userSession.value?.partnership_id || '');
  const userHasPermission = (permission: PermissionAttributes) => {
    if (!userSession.value) return false
    return checkPermission(userSession.value, permission)
  }
  return {
    userHasPermission,
    partnership_id
  }
};
